module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_null.b63a4888.png";